import { useState, useEffect, useContext } from "react";
import useUtilities from "./useutilities";
import { UtilitiesValue } from "../contexts/utilities";

export default function useUtilitySources() {
  const utilities = useUtilities();
  const { utilities: _utilities } = useContext(UtilitiesValue);
  const [actions, setActions] = useState([]);

  useEffect(() => {
    const actions = [];
    _utilities.map((utility) => {
      const schema = utilities.find((x) => x.name === utility.name);
      if (!schema) {
        return;
      }
      schema.returning
        .filter((x) => x.kind === "action")
        .map((a) => {
          let props = [];
          if (a.props) {
            props = a.props.map((p) => {
              const params = {};
              Object.keys(p.editorParams).forEach((key) => {
                if (utility.props[p.editorParams[key]] !== undefined) {
                  params[key] = utility.props[p.editorParams[key]];
                } else {
                  params[key] = p.editorParams[key];
                }
              });
              return { ...p, editorParams: params };
            });
          }
          actions.push({
            displayName: a.displayName,
            props: props,
            name: `${utility.id}.${a.name}`,
            type: utility.displayName,
            frontend: true,
            backend: false,
            async: !!a.async,
            return: a.return || null,
          });
        });
    });
    setActions(actions);
  }, [_utilities, utilities]);
  return actions;
}
